import { render, staticRenderFns } from "./EmitPurchaseStockTransactionForm.vue?vue&type=template&id=17c6dce5"
import script from "./EmitPurchaseStockTransactionForm.vue?vue&type=script&lang=js"
export * from "./EmitPurchaseStockTransactionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports